import { render, staticRenderFns } from "./StoreView.vue?vue&type=template&id=3fa3c81d&lang=pug&"
import script from "./StoreView.vue?vue&type=script&lang=js&"
export * from "./StoreView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports